import { useTranslation } from 'react-i18next';

interface GameModeModalProps {
  onQuickStart: () => void;
  onWithFriends: () => void;
  onFindPlayers: () => void;
  onClose: () => void;
}

export function GameModeModal({ onQuickStart, onWithFriends, onFindPlayers, onClose }: GameModeModalProps) {
  const { t } = useTranslation();

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        className="bg-white dark:bg-slate-900 rounded-[2rem] p-8 max-w-sm w-full shadow-2xl flex flex-col gap-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-black text-slate-800 dark:text-slate-100 text-center">{t('gameMode.title')}</h2>

        <button
          data-testid="game-mode-quick-start"
          onClick={onQuickStart}
          className="w-full p-4 rounded-2xl border-2 border-indigo-200 dark:border-indigo-800 bg-gradient-to-r from-indigo-50 dark:from-indigo-950 to-purple-50 dark:to-purple-950 hover:from-indigo-100 dark:hover:from-indigo-900 hover:to-purple-100 dark:hover:to-purple-900 text-left transition-all hover:scale-[1.01] active:scale-[0.99]"
        >
          <div className="flex items-center gap-3">
            <span className="text-2xl">⚡</span>
            <div>
              <div className="font-black text-slate-800 dark:text-slate-100">{t('gameMode.quickStart')}</div>
              <div className="text-xs text-slate-500 dark:text-slate-400 font-medium">{t('gameMode.quickStartDesc')}</div>
            </div>
          </div>
        </button>

        <button
          data-testid="game-mode-with-friends"
          onClick={onWithFriends}
          className="w-full p-4 rounded-2xl border-2 border-emerald-200 bg-emerald-50 dark:bg-emerald-950 hover:bg-emerald-100 dark:hover:bg-emerald-900 text-left transition-all hover:scale-[1.01] active:scale-[0.99]"
        >
          <div className="flex items-center gap-3">
            <span className="text-2xl">👥</span>
            <div>
              <div className="font-black text-slate-800 dark:text-slate-100">{t('gameMode.withFriends')}</div>
              <div className="text-xs text-slate-500 dark:text-slate-400 font-medium">{t('gameMode.withFriendsDesc')}</div>
            </div>
          </div>
        </button>

        <button
          data-testid="game-mode-find-players"
          onClick={onFindPlayers}
          className="w-full p-4 rounded-2xl border-2 border-amber-200 bg-amber-50 dark:bg-amber-950 hover:bg-amber-100 dark:hover:bg-amber-900 text-left transition-all hover:scale-[1.01] active:scale-[0.99]"
        >
          <div className="flex items-center gap-3">
            <span className="text-2xl">🔍</span>
            <div>
              <div className="font-black text-slate-800 dark:text-slate-100">{t('gameMode.findPlayers')}</div>
              <div className="text-xs text-slate-500 dark:text-slate-400 font-medium">{t('gameMode.findPlayersDesc')}</div>
            </div>
          </div>
        </button>

        <button
          data-testid="game-mode-close"
          onClick={onClose}
          className="w-full py-3 bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 font-bold rounded-xl hover:bg-slate-200 dark:hover:bg-slate-700 transition-all"
        >
          {t('game.back')}
        </button>
      </div>
    </div>
  );
}
